{{#each parameterVariables delimeter="\n"}}
virtual function void {{ setterName }}({{ type }} {{ identifier }});
  this.{{ identifier }} = {{ identifier }};
{{#if relations.parameter.hasMask}}
  update_{{ relations.parameter.maskName }}();
{{/if}}
endfunction
{{/each}}
